import React, { useState, useEffect } from 'react';
import { fetchMedicationStatsSummary } from '../../services/medicationService';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const MedicationStatisticsTab = ({ serverId }) => {
    const [stats, setStats] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadStats = async () => {
            try {
                setIsLoading(true);
                const data = await fetchMedicationStatsSummary(serverId);
                setStats(data);
            } catch (err) {
                console.error("Failed to load medication stats", err);
            } finally {
                setIsLoading(false);
            }
        };
        loadStats();
    }, [serverId]);

    const chartData = stats ? [
        { name: 'Administered', count: stats.totalAdministered || 0, fill: '#38a169' },
        { name: 'Missed', count: stats.totalMissed || 0, fill: '#e53e3e' },
        { name: 'Refused', count: stats.totalRefused || 0, fill: '#dd6b20' }
    ] : [];

    return (
        <div>
            <h2 style={{ fontSize: '20px', color: '#2d3748', marginBottom: '20px' }}>Medication Statistics</h2>
            
            {isLoading ? (
                <div style={{ padding: '40px', textAlign: 'center', color: '#718096' }}>Loading statistics...</div>
            ) : (
                <div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '30px' }}>
                        <div style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', border: '1px solid #e2e8f0', textAlign: 'center' }}>
                            <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#3182ce' }}>{stats?.totalTimesPrescribed || 0}</div>
                            <div style={{ color: '#718096', fontSize: '14px', marginTop: '5px' }}>Total Prescriptions</div>
                        </div>
                        <div style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', border: '1px solid #e2e8f0', textAlign: 'center' }}>
                            <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#38a169' }}>{stats?.totalAdministered || 0}</div>
                            <div style={{ color: '#718096', fontSize: '14px', marginTop: '5px' }}>Total Administered</div>
                        </div>
                        <div style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', border: '1px solid #e2e8f0', textAlign: 'center' }}>
                            <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#e53e3e' }}>{stats?.totalMissed || 0}</div>
                            <div style={{ color: '#718096', fontSize: '14px', marginTop: '5px' }}>Total Missed</div>
                        </div>
                        <div style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', border: '1px solid #e2e8f0', textAlign: 'center' }}>
                            <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#dd6b20' }}>{stats?.totalRefused || 0}</div>
                            <div style={{ color: '#718096', fontSize: '14px', marginTop: '5px' }}>Total Refused</div>
                        </div>
                    </div>

                    <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', border: '1px solid #e2e8f0', height: '400px' }}>
                        <h3 style={{ margin: '0 0 20px 0', color: '#4a5568', fontSize: '16px' }}>Administration Outcomes</h3>
                        <ResponsiveContainer width="100%" height={350}>
                            <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                <XAxis dataKey="name" />
                                <YAxis />
                                <Tooltip />
                                <Bar dataKey="count" />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MedicationStatisticsTab;
